export enum remoteDeviceDeviceBrand {
    Diebold = 1,
    Schlumberger = 2,
    XAC = 3,
    Nokia = 4,
    Demoa = 5,
    PAX = 6,
}

export namespace remoteDeviceDeviceBrand {
    export function values() {
        return Object.keys(remoteDeviceDeviceBrand).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}